import { Outlet, createFileRoute } from "@tanstack/react-router";

import { AdminSidebar } from "~/components/admin-sidebar";
import { AppTopbar } from "~/components/app-topbar";
import { SidebarProvider, SidebarInset } from "~/components/ui/sidebar";
import { requireAdminAccess } from "~/lib/functions/admin-access";

export const Route = createFileRoute("/admin")({
  staticData: { title: "Admin" },
  beforeLoad: async ({ location }) => ({
    adminPermissions: await requireAdminAccess(location),
  }),
  component: AdminLayout,
});

function AdminLayout(): React.ReactElement {
  const { adminPermissions } = Route.useRouteContext();
  return (
    <SidebarProvider>
      <AdminSidebar permissions={adminPermissions} />
      <SidebarInset className="[--app-topbar-h:3.5rem]">
        <AppTopbar />
        <div className="flex-1 px-6 py-6">
          <div className="mx-auto max-w-6xl">
            <Outlet />
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
